jQuery(document).ready(function ($) {
    function isMobile() {
        return window.innerWidth <= 640;
    }

    function toggleVideoClasses() {
        const isCurrentlyMobile = isMobile();

        if (isCurrentlyMobile) {
            $('#videoMobile').removeClass('hidden');
            $('#videoDesktop').addClass('hidden');
        } else {
            $('#videoDesktop').removeClass('hidden');
            $('#videoMobile').addClass('hidden');
        }
    }

    // Initial class setup
    toggleVideoClasses();

    // Add event listener for window resize
    window.addEventListener("resize", function() {
        toggleVideoClasses();
    });
});